//URL変更のため、一時的にリダイレクト設定を残している（4/7記）

const routerTmp = [
  {
    path: '/transactions',
    name: 'TransactionIndex',
    beforeEnter() {
      window.location = '/tx';
    },
  },
  {
    path: '/transactions/:id/message',
    name: 'TransactionIndexMessage',
    redirect: { name: 'TxIndexMessage' },
  },
  {
    path: '/transactions/:id',
    redirect: { name: 'Tx' },
    children: [
      {
        path: 'summary',
        name: 'TransactionSummary',
        redirect: { name: 'TxSummary' },
      },
      {
        path: 'summary/message',
        name: 'TransactionSummaryMessage',
        redirect: { name: 'TxSummaryMessage' },
      },
      {
        path: 'company',
        name: 'TransactionCompany',
        redirect: { name: 'TxCompany' },
      },
      {
        path: 'company/message',
        name: 'TransactionCompanyMessage',
        redirect: { name: 'TxCompanyMessage' },
      },
      {
        path: 'estimate',
        name: 'TransactionEstimate',
        redirect: { name: 'TxEstimate' },
      },
      {
        path: 'estimate/message',
        name: 'TransactionEstimateMessage',
        redirect: { name: 'TxEstimateMessage' },
      },
    ],
  },
];

export default routerTmp;
